import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycResultPendingProps = EventProps

/**
 * @event onboarding_kyc_result_pending
 * @description Emitted when the FrankieOne KYC verification is pending manual review.
 */
export const OnboardingKycResultPendingAnalytics = createAnalyticsStatic<OnboardingKycResultPendingProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_RESULT_PENDING,
)

export default OnboardingKycResultPendingAnalytics
